const DebugConstants = {
    ComponentDidMount: '31',
    CardId: '32',
    ComponentDidUpdate: '33',
    ComponentDidUpdateUpdate: '34',
    ComponentWillUnmount: '35',
    Render: '36',
    SetCardContainer: '37',
    RemoveCardElement: '38',
    AddCardElement: '39',
    TryUpdateCardElementException: '310',
    UpdateCardElementStart: '311',
    UpdateCardElementSkippingRender: '312',
    UpdateCardElementThemeError: '313',
    UpdateCardElementNewCardElementCreated: '314',
    UpdateCardElementAddNewCardElement: '315',
    HideCard: '316',
    ShowCard: '317',
    SetCardVisibility: '318',
    CleanupCard: '319',
    ProcessAutoInvokeActionsNotAllowed: '320',
    ProcessAutoInvokeActionsHasAutoInvoke: '321',
    ProcessAutoInvokeActionsHideCardOnInvoke: '322',
    ProcessAutoInvokeActionsCardIdUndefined: '323',
    ProcessAutoInvokeActionsExecuting: '324',
    ProcessAutoInvokeActionsException: '325',
    ExecuteAutoInvokeActionNoProvider: '326',
    HandleActionResponseStart: '327',
    HandleActionResponseStopUpdate: '328',
    HandleActionSuccessResponseStart: '329',
    HandleActionSuccessResponseOnCardDetailsUpdated: '330',
    HandleActionSuccessResponseHideCard: '331',
    HandleActionSuccessResponseShowCard: '332',
    HandleActionErrorResponseStart: '333',
    HandleActionErrorResponseHideCard: '334',
    HandleActionErrorResponseShowMessage: '335',
    HandleActionErrorResponseHandleAuth: '336',
    HandleActionErrorResponseShowErrorMessage: '337',
};

export default DebugConstants;
